var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58320",
    "data-name": "Group 58320",
    transform: "translate(-1336 -7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_7824",
    "data-name": "Rectangle 7824",
    transform: "translate(1336 7)",
    fill: "#fff",
    stroke: "#eff1f5",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_42191",
    "data-name": "Path 42191",
    d: "M5.141,0a.948.948,0,0,0-.95.95h0V4.179H.95a.993.993,0,0,0-.676.275A.991.991,0,0,0,0,5.13a.965.965,0,0,0,.95.962h3.24v3.24a.95.95,0,1,0,1.9,0h0V6.092H9.344a.965.965,0,0,0,.95-.962.948.948,0,0,0-.95-.95H6.092V.95A.948.948,0,0,0,5.141,0Z",
    transform: "translate(1340.725 19.004) rotate(-45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartBackIcon);
export default __webpack_public_path__ + "static/media/CartBackIcon.dcaf3cb84ceb0c580267a5221bf1ab5a.svg";
export { ForwardRef as ReactComponent };